

export class Persona{
    name="";
    lastName="";
    numPhone;
    email="";
    active;
    avatar;

    constructor(avatar,name,lastName,numPhone,email,active){
       this.name=name;
       this.lastName=lastName;
       this.numPhone=numPhone;
       this.email=email;
       this.active=active;
       this.avatar=avatar;
    }


}


